import { init } from 'sdi/components/modal';

export const { render, register } = init();
export default render;
